import { Logo } from "@/components/Logo";
import { EMAIL, PHONE, PHONE_LABEL, WHATSAPP } from "@/lib/api";

export const Footer = () => (
  <footer className="footer">
    <div className="foot-grid">
      <div>
        <a className="brand" href="#home"><Logo /><span className="brand-name"><strong>KRISHNA</strong><small>GENERATOR SERVICE</small></span></a>
        <p className="foot-note">Reliable power. Professional service.<br />Guwahati & industrial hubs across Assam.</p>
      </div>
      <div className="foot-col"><span>EXPLORE</span><a href="#services">Services</a><a href="#fleet">Fleet</a><a href="#about">About us</a><a href="/admin">Admin login</a></div>
      <div className="foot-col"><span>CONTACT</span><a data-testid="footer-phone-link" href={`tel:${PHONE}`}>{PHONE_LABEL}</a><a data-testid="footer-email-link" href={`mailto:${EMAIL}`}>{EMAIL}</a><a href={WHATSAPP} target="_blank" rel="noreferrer">WhatsApp</a></div>
    </div>
    <div className="foot-big" aria-hidden="true">KRISHNA</div>
    <div className="foot-base"><span>© 2026 M/S KRISHNA GENERATOR SERVICE</span><span>POWER THAT NEVER STOPS.</span></div>
  </footer>
);
